<template>
    <div>
        <v-expansion-panels :accordion="true">
            <v-expansion-panel style="margin-bottom: 12px" v-for="(campaign, i) in campaignList" :key="i">
                <v-expansion-panel-header
                    class="expansion-card"
                    :style="{
                        'border-color': `${generateBorderColor(campaign.target_predictor)}`,
                        filter: `${isCardActive(campaign.is_paused)}`,
                    }"
                >
                    <div class="campaign-card flex">
                        <div class="campaign flex">
                            <div class="icon-section flex" style="background: rgba(96, 191, 129, 0.07)">
                                <img src="../../../../assets/FrontPage/promoteIcon.svg" alt="" />
                            </div>

                            <div class="campaign-details flex">
                                <small class="secondary-font">
                                    {{ campaign.business_profile.name }}
                                </small>
                                <p class="--font">
                                    {{ campaign.campaign_name }}
                                    <v-icon @click="copyCampaignId(campaign.id)" class="ml-2" size="19">
                                        mdi-checkbox-multiple-blank-outline
                                    </v-icon>
                                </p>
                                <div class="flex date-range">
                                    <small class="secondary-font">
                                        {{ formateDate(campaign.promotion_start_date) }}
                                    </small>
                                    <small class="secondary-font"> - </small>
                                    <small class="secondary-font">
                                        {{ formateDate(campaign.promotion_end_date) }}
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="campaign-items">
                            <label>
                                <div class="label">Campaign progress %</div>
                            </label>
                            <div class="flex">
                                <v-progress-linear
                                    class="progree-bar"
                                    :value="campaign.campaign_progress"
                                    color="#1D8D56"
                                    height="7"
                                    :rounded="true"
                                ></v-progress-linear>
                                <p>{{ campaign.campaign_progress }}</p>
                            </div>
                        </div>

                        <div class="campaign-items">
                            <label>
                                <div class="label">Calculated CPM</div>
                            </label>
                            <p class="--font">{{ campaign.calculated_cpm }}</p>
                        </div>
                        <div class="campaign-items">
                            <label>
                                <div class="label">Revenue achieved</div>
                            </label>

                            <p v-if="campaign.revenue_achieved" class="--font">
                                {{ campaign.revenue_achieved }}
                            </p>
                            <p v-else>-</p>
                        </div>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div class="campaign-analytics flex">
                        <v-btn
                            @click="handleViewcampaign(campaign.id)"
                            large
                            class="viewbtn"
                            elevation="0"
                            color="#F4FBFA"
                        >
                            View campaign
                        </v-btn>
                        <!-- <div style="width: 100px"></div> -->
                        <div class="flex column1">
                            <div class="flex numrow">
                                <p style="margin-right: 40px">Total expected revenue</p>
                                <p>{{ campaign.total_expected_revenue }}</p>
                            </div>
                            <div class="flex numrow">
                                <p style="margin-right: 40px">No. of posts</p>
                                <p>
                                    {{
                                        campaign.campaign_active_post_count +
                                        campaign.campaign_paused_post_count +
                                        campaign.campaign_inactive_post_count
                                    }}
                                </p>
                            </div>
                            <div class="flex numrow">
                                <p style="margin-right: 40px">Target</p>
                                <p>{{ campaign.target_count }}</p>
                            </div>
                            <div class="flex numrow">
                                <p style="margin-right: 40px">
                                    CTR
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon size="16" class="icon_axis ml-1" v-bind="attrs" v-on="on"
                                                >mdi-alert-circle-outline</v-icon
                                            >
                                        </template>
                                        <span>Unique click/Unique impression</span>
                                    </v-tooltip>
                                </p>
                                <p v-if="campaign.click_through_ratio">
                                    {{ campaign.click_through_ratio }}
                                </p>
                                <p v-if="!campaign.click_through_ratio">-</p>
                            </div>
                        </div>
                        <div class="flex column1">
                            <div class="flex numrow">
                                <p style="margin-right: 40px">Total impressions</p>
                                <p v-if="campaign.total_campaign_impressions">
                                    {{ campaign.total_campaign_impressions }}
                                </p>
                                <p v-else>-</p>
                            </div>
                            <div class="flex numrow">
                                <p style="margin-right: 40px">Unique users</p>
                                <p v-if="campaign.unique_users">
                                    {{ campaign.unique_users }}
                                </p>
                                <p v-else>-</p>
                            </div>
                            <div class="flex numrow">
                                <p style="margin-right: 40px">Target predictor</p>

                                <div class="flex">
                                    <v-progress-linear
                                        style="margin-bottom: 8px"
                                        class="progree-bar"
                                        :value="campaign.target_predictor"
                                        :color="generateBorderColor(campaign.target_predictor)"
                                        height="7"
                                        :rounded="true"
                                    ></v-progress-linear>
                                    <p>{{ campaign.target_predictor }}</p>
                                </div>
                            </div>
                            <div class="flex numrow">
                                <p style="margin-right: 40px">Campaign Objective</p>
                                <p>{{ campaign.campaign_objective }}</p>
                            </div>
                        </div>
                    </div>
                </v-expansion-panel-content>
                <div v-if="selectedCampaign === campaign.id">
                    <view-campaign
                        :campaign="campaign"
                        :showcampaigncard="showcampaigncard"
                        @closeoverlay="showcampaigncard = false"
                        @reloadApi="reloadApi"
                    />
                </div>
            </v-expansion-panel>
        </v-expansion-panels>

        <!-- campaign numbers -->
    </div>
</template>

<script>
import API_URL from "../../../../helpers/apiUrls";
import accessToken from "../../../../helpers/accessToken";
import viewCampaign from "./view-campaign.vue";
import moment from "moment";
export default {
    name: "campaigncard",
    data() {
        return {
            progress: 30,
            showanalytics: false,
            showcampaigncard: false,
            color: "blue",
            selectedCampaign: "",
        };
    },
    components: {
        "view-campaign": viewCampaign,
    },
    props: {
        campaignList: Array,
    },

    methods: {
        reloadApi() {
            this.$emit("reloadApi");
        },
        handleViewcampaign(id) {
            this.showcampaigncard = true;
            this.selectedCampaign = id;
        },
        isCardActive(isPaused) {
            if (isPaused == true) {
                return "opacity(42%)";
            } else {
                return "opacity(100%)";
            }
        },
        copyCampaignId(campaignId) {
            navigator.clipboard.writeText(campaignId);
            this.showToast(`Campaign Id ${campaignId} copied successfully `, "success", 10000);
        },
        generateBorderColor(color) {
            if (color <= 75) {
                return "red";
            } else if (color > 75 && color <= 95) {
                return "EAB798";
            } else {
                return "green";
            }
        },
        formateDate(datestring) {
            return moment(datestring).format("DD-MMM-YYYY");
        },
        getCampaignList() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("CAMPAIGN LIST-->", response.data);
                    this.campaignList = response.data.data;
                }
            };
            const errorHandler = (response) => {
                this.showToast("Something went wrong internally!", "error", 10000);
            };
            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };
            this.requestGET(API_URL.getCampaignList, {}, headers, successHandler, errorHandler);
        },
    },
};
</script>

<style lang="scss" scoped>
.expansion-card {
    width: 100%;
    border-right: 3px solid;
    border-color: red;
    padding: 22px;
}
.campaign-card {
    width: 90%;
    background-color: #ffffff;
    justify-content: space-between;
    align-items: center;

    border-radius: 3px;

    p {
        margin: 0;
    }
}
.campaign {
    width: 40%;
    justify-content: flex-start;
}
.campaign-details {
    flex-direction: column;
    align-items: flex-start;
    p {
        font-size: 1rem;
        margin: 8px 0px;
    }
    small {
        font-size: 0.7rem;
    }
}
.date-range {
    column-gap: 8px;
}
.icon-section {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    margin-right: 15px;

    img {
        width: 20px;
        height: 20px;
        border-radius: 4px;
    }
}
.progree-bar {
    border-radius: 5px;
    margin-right: 10px;
    min-width: 100px;
}
.campaign-items {
    text-align: center;
    p {
        font-size: 0.9rem;
        color: #333333;
    }
}
.campaign-items {
    justify-content: flex-start;
    column-gap: 2px;
}
.label {
    color: #a6aca9;
    font-size: 0.8rem;
    margin-bottom: 6px;
}
.icon {
    color: #b8b8b8;
    font-size: 2rem;
    margin-right: 30px;
    cursor: pointer;
}

// css for analytics page
.campaign-analytics {
    width: 100%;
    background-color: #ffffff;
    border-radius: 0px 0px 6px 6px;
    padding: 18px 42px 0px 15px;
    justify-content: flex-start;
    column-gap: 50px;
    border-top: 0.5px solid #445149;
}
.viewbtn {
    color: #1d8d56 !important;
    height: 44px !important;
    border-radius: 8px;
    cursor: pointer;
    text-transform: capitalize !important;
    font-size: 14px !important;
    font-weight: 500;
    padding: 10px 30px !important;
}
.column1 {
    flex-direction: column;
    align-items: flex-start;
}
.numrow {
    width: 100%;
    justify-content: space-between;

    p {
        margin-bottom: 12px;
    }
}
.v-expansion-panel-content__wrap {
    padding: 0px 20px 16px;
}
.v-expansion-panel::before {
    box-shadow: none !important;
}
.v-tooltip__content {
  background-color: #fff;
  color: #445149;
  // background: #D8D8D8;
  border: 0.6px solid #979797;
  border-radius: 5px;
  max-width: 250px;
  min-width: 200px;
  text-align: center;
  font-size: 13px;
  padding: 10px 12px;
}
</style>
